module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_sweet_brown_sugar-e425dbcf.png";